import {Injectable} from "@angular/core";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CustomValidators} from "../../validators/CustomValidators";

@Injectable({ providedIn: 'root' })
export class FaleComRhFormFactory {

  constructor(private fb: FormBuilder) {}

  criarFormularioBase(usuario) {
    return this.fb.group({
      id: [null],
      nome: [usuario.nome, Validators.required],
      email: [usuario.email, Validators.required],
      prioridadePessoaIdosa: [usuario.prioridadePessoaIdosa === true],
      username: [usuario.username],
      tipoSolicitante: ['servidor', Validators.required],
      procedimentoFeitoPorTerceiro: [false],
      nomeRepresentanteLegal: [''],
      cpfRepresentanteLegal: [''],
      arquivoRepresentanteLegal: new FormArray([]),
      tipoAssunto: ['', Validators.required],
      demandaRecebida: ['']
    });
  }

  criarGrupoDadosCadastrais() {
    return this.fb.group({
      nomeCompleto: ['', Validators.required],
      matricula: [''],
      cpf: ['', [Validators.required, CustomValidators.cpf]],
      telefoneFixo: ['', CustomValidators.telefone],
      telefoneCelular: ['', [Validators.required, CustomValidators.celular]],
      emailPessoal: ['', [Validators.required, Validators.email]],
      cep: ['', Validators.required],
      logradouro: ['', Validators.required],
      numero: ['', Validators.required],
      complemento: [''],
      bairro: ['', Validators.required],
      pais: ['', Validators.required],
      uf: ['', Validators.required],
      municipio: ['', Validators.required],
      justificativa: [''],
      arquivo: this.fb.array([])
    });
  }



  criarGrupoContaBancaria(): FormGroup {
    return this.fb.group({
      titular: ['', Validators.required],
      cpf: ['', [Validators.required, CustomValidators.cpf]],
      banco: ['341', Validators.required],
      agencia: ['', Validators.required],
      conta: ['', Validators.required],
      digito: ['', Validators.required],
      tipoConta: ['CC'],
      arquivo: this.fb.array([])
    });
  }

  criarGrupoObito(): FormGroup {
    return this.fb.group({
      nomeFalecido:     ['', Validators.required],
      matriculaFalecido:        [''],
      cpfInformante:              ['', [Validators.required, CustomValidators.cpf]],
      telefoneFixoInformante:     ['', CustomValidators.telefone],
      telefoneCelularInformante:  ['', [Validators.required, CustomValidators.celular]],
      emailInformante:     ['', [Validators.required, Validators.email]],
      dataFalecimento:  ['', Validators.required],
      observacoes:      [''],
      arquivo:          this.fb.array([], Validators.required)
    });
  }

  criarGrupoSolicitacaoDocumento(): FormGroup {
    return this.fb.group({
      tipoDocumentoDesejado: ['', Validators.required],
      documentoEspecifico: [''],
      nomeCompleto: [''],
      cpf: [''],
      matricula: [''],
      telefone: [''],
      email: [''],
      emailResposta: [''],
      orgaoDestino: [''],
      finalidade: [''],
      destino: [''],
      objeto: [''],
      agendamento: [''],
      especificar: [''],
      descricaoDetalhada: [''],
      arquivo: this.fb.array([])
    });
  }
}
